import { render, staticRenderFns } from "./ModelRewardrecommentConfig.vue?vue&type=template&id=631fb681&scoped=true&"
import script from "./ModelRewardrecommentConfig.vue?vue&type=script&lang=js&"
export * from "./ModelRewardrecommentConfig.vue?vue&type=script&lang=js&"
import style0 from "./ModelRewardrecommentConfig.vue?vue&type=style&index=0&id=631fb681&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631fb681",
  null
  
)

export default component.exports